import { FeedbotThunk } from '../../../store/types'
import { DialogId, DialogSchema } from '@feedyou/schema'
import { confirm } from '../../../lib/bootbox'
import { Dialogs } from '../../../components/steps/types'
import { getStepWithUniqueIds } from '../../../lib/step'
import { dialogsSelector } from '../selectors/dialogsSelector'
import * as botActions from '../../../actions/bot'
import { slugify } from '../../../lib/transliterate/slugify'

export const unlinkDialog =
  (id: DialogId): FeedbotThunk<Promise<string | null>> =>
  async (dispatch, getState) => {
    const allExistingDialogs = dialogsSelector(getState())

    if (!allExistingDialogs[id]) {
      console.error(`Cannot unlink dialog ${id}, because it does not exist`)
      return null
    }

    const confirmed = await confirm(
      `Do you really want to unlink dialog ${id}? All its steps will be copied to the new dialog and it will be used instead of the old one.`
    )

    if (!confirmed) {
      return null
    }

    const unlinkedDialog = getUnlinkedCopy(id, allExistingDialogs)
    dispatch(botActions.addDialogs({ [unlinkedDialog.id]: unlinkedDialog }))

    return unlinkedDialog.id
  }

export function getUnlinkedCopy(oldDialogId: string, dialogs: Dialogs): DialogSchema {
  //type any, because exporting type of step b  rings typescript problem with flow
  return {
    ...createNextUniqueDialogIdAndName(oldDialogId, dialogs),
    steps: dialogs[oldDialogId]?.steps.map(getStepWithUniqueIds) || []
  }
}

export function getNextUniqueDialogId(dialogId: DialogId, dialogs: Dialogs): DialogId {
  return dialogs[dialogId] ? createNextUniqueDialogIdAndName(dialogId, dialogs).id : dialogId
}

function createNextUniqueDialogIdAndName(
  oldDialogId: DialogId,
  dialogs: Dialogs
): Pick<DialogSchema, 'id' | 'name'> {
  const [, textPart, counterPart] = oldDialogId.match(/^(.*-)(\d+)$/) || []
  const dialogId = textPart ? textPart.slice(0, -1) : oldDialogId
  const dialogName = getDialogNameWithoutCounterPart(
    dialogs[slugify(oldDialogId)]?.name || oldDialogId,
    counterPart
  )

  let counter = counterPart ? parseInt(counterPart) : 1
  let newDialogId, newDialogName
  do {
    counter++
    newDialogId = `${dialogId}-${counter}`
    newDialogName = `${dialogName} ${counter}`
  } while (dialogs[slugify(newDialogId)])
  return { id: newDialogId, name: newDialogName }
}

function getDialogNameWithoutCounterPart(oldDialogName: string, counterPart?: string): string {
  if (counterPart && oldDialogName.endsWith(counterPart)) {
    return oldDialogName.slice(0, -counterPart.length - 1)
  }

  return oldDialogName
}
